export default __webpack_public_path__ + "static/media/caller-board.2ce2e106.svg";